module.exports = __webpack_public_path__ + "static/media/mobile2.f1172adb.png";